import { connect, ConnectedProps } from 'react-redux';

import {
  selectors as siteGroupDataSelectors,
  actions as siteGroupsDataActions,
} from 'src/redux/data/siteGroups';
import {
  selectors as operatorsSelectors,
  actions as operatorsActions,
} from 'src/redux/data/operators';
import {
  selectors as customersSelectors,
  actions as customersActions,
} from 'src/redux/data/customers';
import { selectors as loggedInUserDataSelectors } from 'src/redux/data/loggedInUser';
import { DATA_FETCHING_STATUS } from 'src/redux/data/constants';
import { NETEERA_TENANT } from 'src/utils/constants';
import { RootState } from 'src/redux/store';

const mapStateToProps = (state: RootState) => {
  return {
    siteGroupsList: siteGroupDataSelectors.getSiteGroupsTableData(state)?.data,
    siteGroupsCount:
      siteGroupDataSelectors.getSiteGroupsTableData(state).pageMetadata
        .totalResults,
    excludedFromDeleteSitesGroups: [
      loggedInUserDataSelectors.getUserTenantId(state),
      NETEERA_TENANT,
    ],
    isLoading:
      siteGroupDataSelectors.getSiteGroupsTableDataStatus(state) ===
      DATA_FETCHING_STATUS.LOADING,
    modalStatus: siteGroupDataSelectors.getModalStatus(state),
    operatorsList: operatorsSelectors.selectOperatorsList(state),
    customersList: customersSelectors.selectCustomersList(state),
  };
};

const mapActionCreators = {
  ...siteGroupsDataActions,
  getOperators: operatorsActions.getOperatorsList,
  getCustomers: customersActions.searchCustomers,
};

const Connector = connect(mapStateToProps, mapActionCreators);
export type PropsFromRedux = ConnectedProps<typeof Connector>;
export default Connector;
